// // openWindowPlugin.js 
import { Message } from 'element-ui';
import {getCookieInfo} from '../io/getCookie.js' 
const WindowOpenPlugin = {
	install(vue ) {
		vue.prototype.$windowOpen = function ({ url, isLogin }) {
			
			if (!url) return 
			let token =  localStorage.getItem('token') || getCookieInfo('access_token')||'';  
			if (isLogin && !token) { 
				// 去登录逻辑
				Message({
					message: '请先登录~',
					type: 'warning'
				}); 
			}else if((isLogin&&token)||!isLogin){ 
				window.open(url, '_blank')
			}
			//   if (!isBlank) {
			//     window.open(url)
			//   } else {
			//     window.open(url, '_blank')
			//   }
		}
	}
}

export default WindowOpenPlugin